import VBPublisher from './VBPublisher';

const JitsiMeetJS = window.JitsiMeetJS;

class VBRoom {

    constructor(main, roomId) {
        if (!main) throw new Error('main is required');
        if (!roomId) throw new Error('roomId is required');

        console.log(`VBRoom created`, roomId)
        this._main = main;
        this._roomId = roomId;

        this.isStreaming = false;
        this.publishers = {};
    }

    get roomId() {
        return this._roomId;
    }

    get inputTracks() {
        return this._main.inputTracks;
    }

    get isReadyForPublish() {
        return this._main.isReadyForPublish;
    }

    get isAllConnected() {
        let publishers = this.publishers;
        return (!!publishers.top && publishers.top.connected) && (!!publishers.billboard && publishers.billboard.connected);
    }

    startStreaming() {
        if (this.isStreaming) return console.log(`startStreaming: already running...`, this.roomId);
        if (!this.isReadyForPublish) return console.log(`startStreaming: is not ready...`, this.roomId);
        console.log(`startStreaming`, this.roomId);
        this.isStreaming = true;
        // this.setState({ ...this.state });

        // TOP CAMERA
        this.publishers.top = new VBPublisher(this.roomId, 'TOP');
        this.publishers.top.on('VBPublisher:events', (e) => {
            if (e.event === JitsiMeetJS.events.conference.CONFERENCE_JOINED) {
                this.publishers.top.conference.addTrack(this.inputTracks.top);
            }
        });
        this.publishers.top.connect();

        // BILLBOARD CAMERA
        this.publishers.billboard = new VBPublisher(this.roomId, 'BILLBOARD');
        this.publishers.billboard.on('VBPublisher:events', (e) => {
            if (e.event === JitsiMeetJS.events.conference.CONFERENCE_JOINED) {
                this.publishers.billboard.conference.addTrack(this.inputTracks.billboard);
            }
        });
        this.publishers.billboard.connect();
    }

    stopStreaming() {
        if (!this.isStreaming) return console.log(`stopStreaming: not started yet...`, this.roomId);
        console.log(`stopStreaming`, this.roomId);
        this.isStreaming = false;
        // this.setState({ ...this.state });
        let publishers = this.publishers;
        if (!!publishers.top) {
            publishers.top.dispose();
            publishers.top = null;
        }

        if (!!publishers.billboard) {
            publishers.billboard.dispose();
            publishers.billboard = null;
        }
    }
}

export default VBRoom;